<template>
    <b-row class="cookies-consent-wrapper mr-0 ml-0">
        <div class="cookies-consent p-2 mb-4" v-if="!cookieSet">
            <div class="description">
                <span
                    >Šajā lapā tiek izmantotas sīkdatnes. Nospiežot pogu
                    "Piekrītu", jūs atļaujat to izmantošanu.
                    <b-link
                        :to="'/par-sikdatnem'"
                        class="link-to-cookies-policy"
                        >Uzzināt vairāk.</b-link
                    >
                </span>
            </div>
            <div class="accept-cookies-wrapper">
                <b-button @click="confirm()" class="accept-cookies pl-5 pr-5"
                    >Piekrītu</b-button
                >
            </div>
        </div>
    </b-row>
</template>

<script>
export default {
    name: "cookiesConsent",
    data: () => ({
        cookieSet: false,
    }),
    methods: {
        checkIfCookiesAccepted() {
            const storedConsentCookie = this.$cookies.get(
                "dialekti_cookies_consent_status"
            );

            this.cookieSet = !!storedConsentCookie;
        },
        confirm() {
            this.$cookies.set("dialekti_cookies_consent_status", true, "365d");
            this.cookieSet = true;
        },
    },
    mounted() {
        this.checkIfCookiesAccepted();
    },
};
</script>

<style lang="scss" scoped>
@import "~@/app.scss";

.cookies-consent-wrapper {
    display: flex;
    justify-content: center;
}
.cookies-consent {
    margin: 0 15px;
    z-index: 1;
    max-width: 700px;
    position: fixed;
    bottom: 0;
    background-color: $grey500;
    text-align: center;
    display: flex;

    span {
        color: $white;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
    }

    .link-to-cookies-policy {
        color: $white;
        text-decoration: underline;
    }
}
.description {
    margin-right: 8px;
}
.accept-cookies-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}
.accept-cookies {
    // width: 100%;
    background-color: $grey000;
    color: $red400 !important;

    &:hover {
        background-color: $grey200;
        // color: $red400 !important;
    }
}

@media (max-width: $xs-media) {
    .cookies-consent {
        display: block;
        span {
            font-size: 12px;
        }
    }

    .accept-cookies {
        width: 100%;
        margin-top: 4px;
    }
}
</style>
